import { scales, variants } from "./types";

export const scaleVariants = {
  [scales.MD]: {
    height: "48px",
    padding: "0 24px",
  },
  [scales.MS]: {
    height: "36px",
    padding: "0 16px",
  },
  [scales.SM]: {
    height: "32px",
    padding: "0 16px",
  },
  [scales.XS]: {
    height: "20px",
    fontSize: "12px",
    padding: "0 8px",
  },
};

export const styleVariants = {
  [variants.ATTACK]: {
    backgroundColor: "#EF3A3A",
    color: "white",
  },
  [variants.PRIMARY]: {
    backgroundColor: "primary",
    color: "white",
  },
  [variants.SECONDARY]: {
    backgroundColor: "transparent",
    border: "2px solid",
    borderColor: "primary",
    boxShadow: "none",
    color: "primary",
    ":disabled": {
      backgroundColor: "transparent",
    },
  },
  [variants.TERTIARY]: {
    backgroundColor: "tertiary",
    hoverColor: "primary",
    boxShadow: "none",
    color: "text",
  },
  [variants.TERTIARY_SECONDARY]: {
    backgroundColor: "transparent",
    border: "3px solid",
    borderColor: "tertiary",
    boxShadow: "none",
    color: "tertiary",
    ":disabled": {
      backgroundColor: "transparent",
    },
  },
  [variants.SUBTLE]: {
    backgroundColor: "textSubtle",
    color: "backgroundAlt",
  },
  [variants.DANGER]: {
    backgroundColor: "failure",
    color: "white",
  },
  [variants.SUCCESS]: {
    backgroundColor: "success",
    color: "white",
  },
  [variants.SUCCESS_SECONDARY]: {
    backgroundColor: "transparent",
    border: "3px solid",
    borderColor: "success",
    boxShadow: "none",
    color: "success",
    ":disabled": {
      backgroundColor: "transparent",
    },
  },
  [variants.GRAY_SECONDARY]: {
    backgroundColor: "transparent",
    border: "3px solid",
    borderColor: "gray",
    boxShadow: "none",
    color: "gray",
    ":disabled": {
      backgroundColor: "transparent",
    },
  },
  [variants.TEXT]: {
    backgroundColor: "transparent",
    color: "primary",
    boxShadow: "none",
  },
  [variants.LIGHT]: {
    backgroundColor: "input",
    color: "textSubtle",
    boxShadow: "none",
  },
  [variants.BLUE]: {
    backgroundColor: "#5662f6",
    color: "white",
  },
  [variants.WHITE]: {
    backgroundColor: "white",
    color: "black",
  },
  [variants.PURPLE]: {
    backgroundColor: "#9B48C1",
    color: "white",
  },
  [variants.ROUND]: {
    backgroundColor: "primary",
    color: "white",
    borderRadius: "512px",
  },
  [variants.WATHET]: {
    backgroundColor: "#3ab0ff",
    color: "white",
    borderRadius: "512px",
  },
  [variants.YELLOW]: {
    backgroundColor: "#F78749",
    color: "black",
    borderRadius: "512px",
  },
};
